<template lang="pug">
.customer-booking-wrapper
  .card
    .top
      b-tabs(v-model="tabIndex")
        b-tab-item(label="Suchen" value="search" icon="text-box-outline")
          b-field(label="Suche" label-position="on-border")
            b-input(v-model="searchString")
          .overflow-y
            b-table(:data="searchResults"
                  default-sort-direction="asc"
                  :selected.sync="selected"
                  hoverable)
              b-table-column(field='lastName' label='Nachname' sortable v-slot="props")
                | {{ props.row.lastName }}
              b-table-column(field='firstName' label='Vorname' sortable v-slot="props")
                | {{ props.row.firstName }}
              b-table-column(field='address.city' label='Stadt' sortable v-slot="props")
                | {{ props.row.address.city }}
              b-table-column(field='address.email' label='E-Mail' sortable v-slot="props")
                | {{ props.row.address.email }}
          .button-wrapper.right
            button.button.is-primary(@click="selectCustomer(selected)" :disabled="!selected") {{selected && selected.lastName ? selected.lastName : ''}} Auswählen

        b-tab-item(label="Anlegen" value="create" icon="plus")
          ValidationObserver(ref="newform")
            .form
              b-field(grouped)
                ValidationProvider(name="Anrede" :rules="needFullAddress ? 'required' : ''" v-slot="{ errors, valid }") 
                  b-field(label="Anrede" label-position="on-border"
                          :type="{ 'is-danger': errors[0] }" :message="errors")
                    b-select(v-model="newFormData.salutation")
                      option(value="Frau") Frau
                      option(value="Herr") Herr
                .spacer.sm
                ValidationProvider(name="Titel" rules="" v-slot="{ errors, valid }") 
                  b-field(label="Titel" label-position="on-border"
                          :type="{ 'is-danger': errors[0] }" :message="errors")
                    b-input(v-model="newFormData.title" tabindex="-1")
              b-field(grouped)
                ValidationProvider(name="Vorname" :rules="needFullAddress ? 'required' : ''" v-slot="{ errors, valid }") 
                  b-field(label="Vorname" label-position="on-border"
                          :type="{ 'is-danger': errors[0] }" :message="errors")
                    b-input(v-model="newFormData.firstName")
                .spacer.sm
                ValidationProvider(name="Nachname" rules="required" v-slot="{ errors, valid }") 
                  b-field(label="Nachname (Pflichtfeld)" label-position="on-border"
                          :type="{ 'is-danger': errors[0] }" :message="errors")
                    b-input(v-model="newFormData.lastName")
              ValidationProvider(name="Straße und HausNr." :rules="needFullAddress ? 'required' : ''" v-slot="{ errors, valid }") 
                b-field(label="Straße und HausNr." label-position="on-border"
                        :type="{ 'is-danger': errors[0] }" :message="errors")
                  b-input(v-model="newFormData.address.street")
              b-field(grouped)
                ValidationProvider(name="PLZ" :rules="needFullAddress ? 'required' : ''" v-slot="{ errors, valid }") 
                  b-field(label="PLZ" label-position="on-border"
                          :type="{ 'is-danger': errors[0] }" :message="errors")
                    b-input(v-model="newFormData.address.zip")
                .spacer.sm
                ValidationProvider(name="Stadt" :rules="needFullAddress ? 'required' : ''" v-slot="{ errors, valid }") 
                  b-field(label="Stadt" label-position="on-border"
                          :type="{ 'is-danger': errors[0] }" :message="errors")
                    b-input(v-model="newFormData.address.city" @focus="() => findAndUpdateCityByZip(newFormData.address.zip)")
              ValidationProvider(name="E-Mail" rules="email" v-slot="{ errors, valid }") 
                b-field(label="E-Mail" label-position="on-border"
                        :type="{ 'is-danger': errors[0] }" :message="errors")
                  b-input(v-model="newFormData.address.email")
              b-field(grouped)
                ValidationProvider(name="Handy" rules="" v-slot="{ errors, valid }") 
                  b-field(label="Handy" label-position="on-border"
                          :type="{ 'is-danger': errors[0] }" :message="errors")
                    b-input(v-model="newFormData.address.mobile")
                .spacer.sm
                ValidationProvider(name="Telefon" rules="" v-slot="{ errors, valid }") 
                  b-field(label="Telefon" label-position="on-border"
                          :type="{ 'is-danger': errors[0] }" :message="errors")
                    b-input(v-model="newFormData.address.phone")
              b-field
                b-switch(type="is-success" v-model="formData.gdprOptIn") DSGVO Einverständnis

              b-message(v-if="!newFormData.lastName" type="is-danger") Es fehlt der Nachname, damit ein Gast angelegt werden kann.
              .button-wrapper.right(v-if="showCreateButton || formData.id")
                b-button(type="is-primary" @click="createCustomer()") Gast speichern

        b-tab-item(v-if="formData.id" label="Ausgewählter Gast" value="selected" icon="account-outline")
          ValidationObserver(ref="selectForm")
            .form
              b-field(grouped)
                ValidationProvider(name="Anrede" :rules="needFullAddress ? 'required' : ''" v-slot="{ errors, valid }") 
                  b-field(label="Anrede" label-position="on-border"
                          :type="{ 'is-danger': errors[0] }" :message="errors")
                    b-select(v-model="formData.salutation")
                      option(value="Frau") Frau
                      option(value="Herr") Herr
                .spacer.sm
                ValidationProvider(name="Titel" rules="" v-slot="{ errors, valid }") 
                  b-field(label="Titel" label-position="on-border"
                          :type="{ 'is-danger': errors[0] }" :message="errors")
                    b-input(v-model="formData.title" tabindex="-1")
              b-field(grouped)
                ValidationProvider(name="Vorname" :rules="needFullAddress ? 'required' : ''" v-slot="{ errors, valid }") 
                  b-field(label="Vorname" label-position="on-border"
                          :type="{ 'is-danger': errors[0] }" :message="errors")
                    b-input(v-model="formData.firstName")
                .spacer.sm
                ValidationProvider(name="Nachname" rules="required" v-slot="{ errors, valid }") 
                  b-field(label="Nachname (Pflichtfeld)" label-position="on-border"
                          :type="{ 'is-danger': errors[0] }" :message="errors")
                    b-input(v-model="formData.lastName")
              ValidationProvider(name="Straße und HausNr." :rules="needFullAddress ? 'required' : ''" v-slot="{ errors, valid }") 
                b-field(label="Straße und HausNr." label-position="on-border"
                        :type="{ 'is-danger': errors[0] }" :message="errors")
                  b-input(v-model="formData.address.street")
              b-field(grouped)
                ValidationProvider(name="PLZ" :rules="needFullAddress ? 'required' : ''" v-slot="{ errors, valid }") 
                  b-field(label="PLZ" label-position="on-border"
                          :type="{ 'is-danger': errors[0] }" :message="errors")
                    b-input(v-model="formData.address.zip")
                .spacer.sm
                ValidationProvider(name="Stadt" :rules="needFullAddress ? 'required' : ''" v-slot="{ errors, valid }") 
                  b-field(label="Stadt" label-position="on-border"
                          :type="{ 'is-danger': errors[0] }" :message="errors")
                    b-input(v-model="formData.address.city")
              ValidationProvider(name="E-Mail" rules="email" v-slot="{ errors, valid }") 
                b-field(label="E-Mail" label-position="on-border"
                        :type="{ 'is-danger': errors[0] }" :message="errors")
                  b-input(v-model="formData.address.email")
              b-field(grouped)
                ValidationProvider(name="Handy" rules="" v-slot="{ errors, valid }") 
                  b-field(label="Handy" label-position="on-border"
                          :type="{ 'is-danger': errors[0] }" :message="errors")
                    b-input(v-model="formData.address.mobile")
                .spacer.sm
                ValidationProvider(name="Telefon" rules="" v-slot="{ errors, valid }") 
                  b-field(label="Telefon" label-position="on-border"
                          :type="{ 'is-danger': errors[0] }" :message="errors")
                    b-input(v-model="formData.address.phone")
                    
              b-field
                b-switch(type="is-success" v-model="formData.gdprOptIn") DSGVO Einverständnis

              .button-wrapper.right(v-if="needUpdate")
                b-button(type="is-light" @click="restoreCustomer()") Änderungen verwerfen
                b-button(type="is-primary" @click="updateCustomer()") Gast aktualisieren
</template>

<script>
import { DateTime } from "luxon"

export default {
  props: {
    existingCustomer: {
      type: Object
    },
    needFullAddress: {
      type: Boolean
    },
    showCreateButton: {
      type: Boolean
    }
  },
  data() {
    return {
      searchResults: [],
      selected: null,
      searchString: "",
      tabIndex: "search",
      needUpdate: false,
      formData: {
        salutation: "Frau",
        title: null,
        firstName: null,
        lastName: null,
        birthday: null,
        comment: "",
        gdprOptIn: false,
        address: {
          line1: null,
          line2: null,
          street: null,
          zip: null,
          city: null,
          country: "Deutschland",
          email: null,
          email2: null,
          phone: null,
          mobile: null
        }
      },
      newFormData: {
        salutation: "Frau",
        title: null,
        firstName: null,
        lastName: null,
        birthday: null,
        comment: "",
        address: {
          line1: null,
          line2: null,
          street: null,
          zip: null,
          city: null,
          country: "Deutschland",
          email: null,
          email2: null,
          phone: null,
          mobile: null
        }
      }
    };
  },
  async mounted() {
    // if (this.$route.query.fromCustomer) {
    //   const customer = await this.$store.dispatch("customers/findOne", { id: this.$route.query.fromCustomer });
    //   this.$emit('selectCustomer', customer);
    // }
  },
  watch: {
    searchString() {
      this.selected = null
      this.updateSearch()
    },
    tabIndex() {
      if (this.tabIndex === 'create' && this.searchString.split(' ').length === 1) {
        this.newFormData.lastName = this.searchString;
      }
    },
    existingCustomer: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.id) {
          this.formData = JSON.parse(JSON.stringify(newVal));
          this.tabIndex = 'selected';
        }
      }
    },
    formData: {
      deep: true,
      handler(newVal, oldVal) {
        if (oldVal && oldVal.lastName && newVal.id === oldVal.id) {
          this.needUpdate = true;
          this.$emit('customerDataNeedUpdate');
        }
      }
    }
  },
  methods: {
    async findAndUpdateCityByZip(zip) {
      const foundCity = await this.$store.dispatch("addresses/findCity", {zip: zip})
      this.newFormData.address.city = foundCity;
    },
    async updateSearch() {
      this.searchResults = await this.$store.dispatch("customers/search", {searchString: this.searchString})
    },
    formatDate(d) {
      const dt = DateTime.fromISO(d);
      return dt.setLocale('de')
        .toFormat("dd. LLL. yy")
    },
    restoreCustomer() {
      if (this.formData.firstName) {
        this.formData = JSON.parse(JSON.stringify(this.existingCustomer));
        this.$nextTick(()=> {
          this.needUpdate = false;
          this.$emit('customerDataIsUpdate');
        });
      }
    },
    selectCustomer(selected) {
      this.formData = selected;
      this.$emit('selectCustomer', selected);
      this.$nextTick(() => {
        this.tabIndex = 'selected';
      });
    },
    checkForUnsavedDate() {
      if (this.needUpdate) {
        this.$buefy.dialog.confirm({
            title: 'Nicht gespeicherte Gastdaten',
            message: 'Die Gastdaten wurden verändert, aber nicht gespeichert. Wie möchten Sie weiter vorgehen?',
            cancelText: 'Neue Gastdaten verwerfen',
            confirmText: 'Gastdaten speichern',
            type: 'is-info',
            hasIcon: true,
            onCancel: () => this.$emit('reloadCustomerData'),
            onConfirm: () => this.updateCustomer()
        })
      }
    },
    async updateCustomer() {
      this.$refs.selectForm.validate().then(async success => {
        if (!success) {
          this.$buefy.dialog.alert({
            title: 'Gastdaten sind unvollständig',
            message: 'Bitte überprüfen Sie alle Felder.',
            type: 'is-warning',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
          return;
        }

        this.formData.birthday = DateTime.fromJSDate(this.formData.birthday).toISODate();
        const updatedCustomer = await this.$store.dispatch("customers/update", this.formData);
        this.$emit('selectCustomer', updatedCustomer);
        this.$nextTick(() => {
          this.$emit('customerDataIsUpdate');
          this.needUpdate = false;
        });
      });
    },
    createCustomer(callback) {
      if (this.tabIndex !== "create") {
        if (callback) callback();
        return
      }
      this.$refs.newform.validate().then(async success => {
        if (!success || !this.newFormData.lastName) {
          this.$buefy.dialog.alert({
            title: 'Gastdaten sind unvollständig',
            message: 'Damit ein Mietvertrag erstellt werden kann, müssen alle Felder ausgefüllt werden',
            type: 'is-warning',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
          return;
        }

        this.newFormData.birthday = DateTime.fromJSDate(this.newFormData.birthday).toISODate();
        const newCustomer = await this.$store.dispatch("customers/create", this.newFormData);
        this.$emit('selectCustomer', newCustomer);

        this.$nextTick(() => {
          this.tabIndex = 'selected';
        });
        if (callback) callback();
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.customer-booking-wrapper {
  .overflow-y {
    max-height: 320px;
    overflow-y: auto;
    overflow-x: hidden;
    border: solid 1px $lightgray;
    border-radius: 3px;
  }
}
.button-wrapper {
  padding: $sm-space;
}
</style>